export default __webpack_public_path__ + "static/artnet-2d7c1abfaf996c574f9a2aac192202c5.png";